import React , {useContext} from 'react'
import "./coupons.css"
import CartContext from '../../../../context/cart_context'
import {calculateOriginalPrice} from "../../../../functions/mini_func";


const CouponItems = ({coupon ,setShowValidCoupon ,setShowCoupons , setSelectedCoupon }) => {

  const {cartItems , selectedfoodItemList , setCouponAmount } = useContext(CartContext);

  // Current cart sub-total (item-level discounts applied, pre-GST) — the same
  // basis used for both eligibility and the discount calculation.
  let cartTotal = 0;
  if (selectedfoodItemList.length !== 0) {
    Object.entries(cartItems).forEach(([key, value]) => {
      const item = selectedfoodItemList.find((it) => it.dbID == key);
      if (item) {
        cartTotal += calculateOriginalPrice(item.discount, parseFloat(item.price)) * value;
      }
    });
  }

  const minOrder = parseFloat(coupon.minimumOrderValue) || 0;
  const isEligible = cartTotal >= minOrder;
  const amountNeeded = Math.max(0, Math.ceil(minOrder - cartTotal));

  const applyCoupon = () => {
    // Ineligible coupons are shown but disabled — clicking does nothing.
    if (!isEligible) return;

    const discAmount = cartTotal * (parseFloat(coupon.discount) / 100);
    const amount = discAmount < parseFloat(coupon.maximumDiscountValue)
      ? Math.trunc(discAmount)
      : parseFloat(coupon.maximumDiscountValue);

    setShowValidCoupon(true);
    setSelectedCoupon(coupon);
    setCouponAmount(amount);
    setShowCoupons(false);
  };

  return (
    <div
      onClick={applyCoupon}
      aria-disabled={!isEligible}
      className={`coupon-items-container${isEligible ? "" : " coupon-disabled"}`}
    >
        <div className='coupon-data-container'>
            <h4>{`${coupon.discount}% OFF`}</h4>
            <span>{`Max  ${coupon.maximumDiscountValue}`}</span>
            <p>{coupon.offerTitle}</p>
            {!isEligible && (
              <p className='coupon-min-hint'>
                {`Add ₹${amountNeeded} more (min order ₹${minOrder})`}
              </p>
            )}
        </div>
        <h4>{coupon.couponCode}</h4>
    </div>
  )
}

export default CouponItems
